import { render } from "./InterfaceRecord.vue?vue&type=template&id=66d08fb8&scoped=true"
import script from "./InterfaceRecord.vue?vue&type=script&lang=js"
export * from "./InterfaceRecord.vue?vue&type=script&lang=js"

import "./InterfaceRecord.vue?vue&type=style&index=0&id=66d08fb8&lang=scss&scoped=true"
import "./InterfaceRecord.vue?vue&type=style&index=1&id=66d08fb8&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d08fb8"]])

export default __exports__